import type { GytrState } from 'types/gytr';
import type { PaywallContext } from 'types/paywall';

/**
 * Builds the §8.0 paywall payload for a GYTR funnel: the squad rating is the
 * single metric. Returns null until the rating has been calculated, so the
 * paywall falls back to its generic copy.
 */
export const buildGytrPaywallContext = (
  state: GytrState
): PaywallContext | null => {
  if (state.teamRating === null) return null;
  return { metricValue: state.teamRating };
};
